import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject, Subscription } from 'rxjs';

import { AuthenticationService } from './authentication.service';
import { CredentialService } from './credential.service';

import {
  OA,
  SHEETS
} from '../../ngrx/category-types';
import { inflate } from 'zlib';
import { allCapacityConfigFields } from 'ngrx/graphql';
import { CapacityConfig } from 'app/models/capacityConfig.model';

const errorCodes = [400, 401, 403, 404];

@Injectable()
export class CapacityConfigService {

    constructor(private authService: AuthenticationService,
        private credentialService: CredentialService,
        private store: Store<any>
    ) { }

    private invokeCapacityConfig(payload: any): Observable<any> {
        return new Observable(observer => {
        
        this.credentialService.lambda.invoke({
            FunctionName: environment.batchFunction,
            Payload: JSON.stringify(payload)
            }, (err, data) => {
            if (err) {
                if (errorCodes.find(code => code === err.statusCode) && localStorage.getItem('currentUser')) {
                this.authService.refreshCredentials();
                }
                observer.error(err);
            } else {
                const output = typeof data.Payload === 'string'
                    ? JSON.parse(data.Payload)
                    :       data.Payload;
                if(output.gzip){
                const options = {
                    windowBits : 15
                };
                inflate(new Buffer(output.body,'base64'), options, (err, data) => {
                    if (err) {                    
                    observer.error(err.stack);
                    } else {
                    const unzippedOutput = Object.assign({}, output, {
                        body: data.toString()
                    });
                    observer.next(unzippedOutput);
                    }
                });
                } else {
                observer.next(output);
                }
            }
            }
        );
        });
    }

    private invokeCapacityConfigMutation(payload: any): void {
        this.credentialService.lambda.invoke({
        FunctionName: environment.batchFunction,
        Payload: JSON.stringify(payload)
        }, (err, data) => {
            if (err) {
            if (errorCodes.find(code => code === err.statusCode) && localStorage.getItem('currentUser')) {
                this.authService.refreshCredentials();
            }
            }
        }
        );
    }

    createCapacityConfigs(capacityConfigs: CapacityConfig[]): Observable<any> {
        const variables = { capacityConfigs };
        const query = `mutation($capacityConfigs: [CapacityConfigInput]) {
        createCapacityConfigs(capacityConfigs: $capacityConfigs) {
            ${allCapacityConfigFields}
        }
        }`;

        return this.invokeCapacityConfig({ query, variables });
    }

    getCapacityConfig(compKey: string): Observable<any> {
        const query = `{
            capacityConfig(compKey: "${compKey}") {
                ${allCapacityConfigFields}
            }
        }`;

        return this.invokeCapacityConfig({ query });
    }

    getCapacityConfigs(param: string, value: string): Observable<any> {
        const query = `{
            capacityConfigs(param:"${param}", value:"${value}") {
                ${allCapacityConfigFields}
            }
        }`;

        return this.invokeCapacityConfig({ query });
    }

    getCapacityConfigsOA(param: string, value: string): Observable<any> {
        const query = `{
            capacityConfigsOA(param:"${param}", value:"${value}") {
                ${allCapacityConfigFields}
            }
        }`;

        return this.invokeCapacityConfig({ query });
    }

    getCapacityConfigHistory(category: string, from: string, to: string): Observable<any> {
        console.log(`CapacityConfig history from: ${from}`);
        console.log(`CapacityConfig history to: ${to}`);
        const query = `{
        capacityConfigHistory(category: "${category}", from: "${from}", to: "${to}") {
            ${allCapacityConfigFields}
        }
        }`;

        return this.invokeCapacityConfig({ query });
    }

    updateCapacityConfig(capacityConfig: CapacityConfig): void {
        const variables = { capacityConfig };
        const query = `mutation ($capacityConfig: CapacityConfigInput!) {
            updatecCapacityConfig(capacityConfig: $capacityConfig) {
                ${allCapacityConfigFields}
            }
        }`;

        this.invokeCapacityConfigMutation({ query, variables });
    }

    updateCapacityConfigs(capacityConfigs: CapacityConfig[]): Observable<any> {
        const variables = { capacityConfigs };
        const query = `mutation ($capacityConfigs: [CapacityConfigInput]) {
            updateCapacityConfigs(capacityConfigs: $capacityConfigs) {
                ${allCapacityConfigFields}
            }
        }`;

        return this.invokeCapacityConfig({ query, variables });
    }
}


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/services/capacity-config.service.ts